import { LazyMotion, MotionConfig } from "motion/react";

// Site-wide setup for the Motion library (motion/react).
//
// Motion is used ONLY where JavaScript has to own an animation: route
// transitions (the outgoing page must stay mounted while it fades). One-time entrances of
// static content - the scroll reveals - are CSS keyframes instead; see
// src/components/Motion/reveal/ and CLAUDE.md, "Motion", for why.
//
// - LazyMotion + `m` components keep the core small; the animation features load
//   as a separate chunk. `strict` makes an accidental full `motion.div` import
//   throw in development instead of silently re-bloating the bundle.
// - reducedMotion="user": for visitors who ask for less motion, Motion skips
//   transform animations and keeps only opacity.
const loadFeatures = () => import("./motionFeatures").then((mod) => mod.default);

const MotionProvider = ({ children }) => (
  <LazyMotion features={loadFeatures} strict>
    <MotionConfig reducedMotion="user">{children}</MotionConfig>
  </LazyMotion>
);

export default MotionProvider;
